import { render, staticRenderFns } from "./PagePicker.vue?vue&type=template&id=80f01bcc&scoped=true&"
import script from "./PagePicker.vue?vue&type=script&lang=js&"
export * from "./PagePicker.vue?vue&type=script&lang=js&"
import style0 from "./PagePicker.vue?vue&type=style&index=0&id=80f01bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f01bcc",
  null
  
)

export default component.exports